<template>
  <el-container
    style="
      width: 1200px;
      margin: 0 auto;
      color: #606266;
      background-color: #fff;
      border-radius: 26px;
      padding: 20px 30px;
    "
  >
    <el-aside
      style="
        width: 300px;
        color: #606266;
        overflow-y: auto;
        scrollbar-width: none;
      "
    >
      <el-tooltip
        effect="dark"
        content="跳转至个人中心"
        placement="right-start"
      >
        <span @click="$router.push('/user/center')" style="cursor: pointer">
          <div style="width: 57px; margin: 0px auto">
            <img width="56px" height="56px" src="@/assets/img/yonghu.png" />
          </div>
        </span>
      </el-tooltip>
      <div
        style="display: flex; justify-content: space-between; padding-top: 20px"
      >
        <span class="secondary"> 欢迎您: </span>
        <span>{{ user.realName }}</span>
      </div>
      <div
        style="display: flex; justify-content: space-between; padding-top: 20px"
      >
        <span class="secondary"> 我的部门: </span>
        <span> {{ user.deptName }}</span>
      </div>
      <div
        style="display: flex; justify-content: space-between; padding-top: 20px"
      >
        <span class="secondary"> 上次登录时间: </span>
        <span>{{ user.lastLoginTime }}</span>
      </div>
      <el-divider></el-divider>
      <el-tooltip
        class="item"
        effect="dark"
        content="跳转至我的待办"
        placement="right-start"
      >
        <span @click="$router.push('/system/dealt')" style="cursor: pointer">
          <div style="width: 57px; margin: 0px auto" class="noticeDiv">
            <img width="56px" height="56px" src="@/assets/images/daiban.png" />
            <el-badge
              :value="waitDealtCount"
              class="item"
              :hidden="waitDealtCount == 0"
            >
              <div style="width: 56px; text-align: center; color: #606266">
                待办
              </div>
            </el-badge>
          </div>
          <div
            style="text-align: center; margin-top: 20px"
            v-if="waitDealtCount <= 0"
          >
            暂无未完成的待办
          </div>
        </span>
      </el-tooltip>

      <el-collapse
        style="margin-top: 10px; min-height: 100px"
        :accordion="true"
      >
        <el-collapse-item
          v-for="(item, index) in dealtData"
          :title="item.dealtTitle"
          :name="index"
          :key="index"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              padding-top: 20px;
            "
          >
            <span class="secondary"> 预计处理时间: </span>
            <span style="color: #f56c6c">
              {{ item.dealtStartTime }} - {{ item.dealtEndTime }}</span
            >
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              padding-top: 20px;
            "
          >
            <span class="secondary"> 待办详情: </span>
          </div>
          <div>{{ item.remarks }}</div>
        </el-collapse-item>
      </el-collapse>

      <el-divider></el-divider>

      <el-tooltip
        effect="dark"
        content="跳转至消息中心"
        placement="right-start"
      >
        <span @click="$router.push('/sys/siteLetter')" style="cursor: pointer">
          <div style="width: 57px; margin: 0px auto" class="noticeDiv">
            <img width="56px" height="56px" src="@/assets/img/gonggao.png" />
            <el-badge
              :value="sysSiteLetterCount"
              :hidden="sysSiteLetterCount == 0"
            >
              <div style="width: 56px; text-align: center; color: #606266">
                通知
              </div>
            </el-badge>
          </div>
          <div
            style="text-align: center; margin-top: 20px"
            v-if="sysSiteLetterCount <= 0"
          >
            暂无通知
          </div>
        </span>
      </el-tooltip>

      <el-collapse
        style="margin-top: 10px; min-height: 100px"
        :accordion="true"
      >
        <el-collapse-item
          :title="item.letterTitle"
          v-for="(item, index) in sitetData"
          :key="index"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              padding-top: 20px;
            "
          >
            <span class="secondary"> 发布时间: </span>
            <span style="color: #f56c6c"> {{ item.createTime }}</span>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              padding-top: 20px;
            "
          >
            <span class="secondary"> 站内信详情: </span>
          </div>
          <div>
            {{ item.letterBody }}
            <el-button
              v-if="item.letterHref"
              type="text"
              size="small"
              @click="$router.push(item.letterHref)"
            >
              <i class="el-icon-s-order"></i>快捷操作
            </el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-aside>

    <el-main style="padding-left: 70px">
      <div style="height: 210px; margin-left: 30px">
        <div style="width: 100%; height: 100%">
          <img src="@/assets/img/6412cbe3c671b9aee31adf933fec22d.png" />
        </div>
      </div>
      <div v-for="(power, index) in powerList" :key="index">
        <div style="margin-top: 10px">
          <span class="secondary" style="font-size: 12px"
            >{{ power.menuName }}
          </span>
        </div>
        <div style="margin-top: 10px">
          <span
            v-for="(domain, index) in power.children"
            :key="index"
            class="badgeSpan"
          >
            <el-badge
              :value="waitAuditCount"
              :hidden="
                waitAuditCount === 0 || domain.count !== 'waitDealtCount'
              "
            >
              <div class="butDiv" @click="$router.push(domain.webUrl)">
                <div class="smallbutDiv">
                  <img class="butImg" :src="domain.icon" />
                  <span class="butSpan"> {{ domain.menuName }}</span>
                </div>
              </div>
            </el-badge>
          </span>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { AesDecrypt } from "../util";
import { requestGetHomeInfoAndSite } from "../api";

export default {
  name: "Home",
  data() {
    return {
      applyNum: 0,
      user: {},
      dealtData: [
        {
          dealtTitle: "宁乡不动产项目实施",
          dealtStartTime: "2023-02-20 10:47",
          dealtEndTime: "2023-02-30 10:47",
          remarks: "宁乡不动产项目实施",
        },
        {
          dealtTitle: "天网五期设备网络系统配置",
          dealtStartTime: "2023-02-30 10:47",
          dealtEndTime: "2023-03-10 10:47",
          remarks: "天网五期设备网络系统配置",
        },
      ],
      waitDealtCount: 0,
      sysSiteLetterCount: 0,
      waitAuditCount: 0,
      sitetData: [
        {
          lettertitle: "您的用章申请已通过",
          createTime: "2023-02-08 10:47",
          letterBody: "您的用章申请已通过",
          letterHref: "user/center",
        },
        {
          lettertitle: "您的项目申请已通过",
          createTime: "2023-02-08 10:47",
          letterBody: "您的用章申请已通过",
          letterHref: "user/center",
        },
      ],
      powerList: [
        {
          menuName: "申请管理",
          children: [
            {
              webUrl: "/my/apply/list",
              icon: require("@/assets/img/shenqing.png"),
              menuName: "我的申请",
              count: "myApplyCount",
            },
            {
              webUrl: "/my/apply/wait",
              icon: require("@/assets/img/daishenhe.png"),
              menuName: "我的待审核",
              count: "waitDealtCount",
            },
            {
              webUrl: "/my/apply/record",
              icon: require("@/assets/img/jilu.png"),
              menuName: "我的审批记录",
            },
            {
              webUrl: "/my/outReport/record",
              icon: require("@/assets/img/muban.png"),
              menuName: "我的外出",
            },
          ],
        },
        {
          menuName: "申请功能",
          children: [
            {
              webUrl: "/item/project",
              icon: require("@/assets/img/gangwei.png"),
              menuName: "立项申请",
              count: "regionPostManageCount",
            },
            {
              webUrl: "/item/costreport",
              icon: require("@/assets/img/gangwei.png"),
              menuName: "招待费报备",
              count: "regionPostManageCount",
            },
            {
              webUrl: "/item/reimburse",
              icon: require("@/assets/img/gangwei.png"),
              menuName: "费用报销申请",
              count: "regionPostManageCount",
            },
            {
              webUrl: "/item/outreport",
              icon: require("@/assets/img/gangwei.png"),
              menuName: "外出申请",
              count: "regionPostManageCount",
            },
            {
              webUrl: "/item/leave",
              icon: require("@/assets/img/gangwei.png"),
              menuName: "请假申请",
              count: "regionPostManageCount",
            },
            {
              webUrl: "/item/coworking",
              icon: require("@/assets/img/gangwei.png"),
              menuName: "协同办公申请",
              count: "regionPostManageCount",
            },
            // {
            //   webUrl: "/item/enforce",
            //   icon: require("@/assets/img/renwu.png"),
            //   menuName: "实施文件归档申请",
            //   //count: 'regionManageCount',
            // },
            {
              webUrl: "/item/payment",
              icon: require("@/assets/img/renwu.png"),
              menuName: "付款申请单",
              //count: 'regionManageCount',
            },
            {
              webUrl: "/item/seal",
              icon: require("@/assets/img/renwu.png"),
              menuName: "用章申请",
              //count: 'regionManageCount',
            },
            {
              webUrl: "/item/contract",
              icon: require("@/assets/img/renwu.png"),
              menuName: "合同归档申请",
              //count: 'regionManageCount',
            },
            {
              webUrl: "/item/projectModify",
              icon: require("@/assets/img/renwu.png"),
              menuName: "项目变更申请",
              //count: 'regionManageCount',
            },
            {
              webUrl: "/item/purchase",
              icon: require("@/assets/img/renwu.png"),
              menuName: "采购申请",
              //count: 'regionManageCount',
            },
            {
              webUrl: "/item/allege",
              icon: require("@/assets/img/renwu.png"),
              menuName: "考勤申述",
            },
            {
              webUrl: "/item/invoice",
              icon: require("@/assets/img/renwu.png"),
              menuName: "发票开具申请",
            },
            {
              webUrl: "/item/delivery",
              icon: require("@/assets/img/renwu.png"),
              menuName: "项目交付申请",
            },
            {
              webUrl: "/item/pettyCash",
              icon: require("@/assets/img/renwu.png"),
              menuName: "备用金申请",
            },
          ],
        },
      ],
    };
  },
  methods: {
    async getHomeData() {
      const res = await requestGetHomeInfoAndSite();
      if (res.code == 200) {
        this.dealtData = res.object.dealtData;
        this.sitetData = res.object.sitetData;
        this.waitAuditCount = res.object.waitAuditCount;
        this.sysSiteLetterCount = res.object.sysSiteLetterCount;
        this.waitDealtCount = res.object.waitDealtCount;
      }
    },
  },
  created() {
    let data = AesDecrypt(window.localStorage.getItem("user"));
    this.user = JSON.parse(data);
    this.getHomeData();
    this.$store.commit("resetRoute");
  },
};
</script>

<style scoped>
.box {
  margin-right: 25px;
  display: flex;
  line-height: 58px;
  width: 224px;
  vertical-align: middle;
  height: 58px;
  border: 1px solid #c3c6ce;
  background: #fff;
  outline: 0;
  cursor: pointer;

  border-radius: 8px;
}

.box:hover {
  border-radius: 8px;
  border-color: rgb(125, 128, 137);
}

.box img {
  width: 100%;
  height: 100%;
  line-height: 58px;
}

.box .img {
  width: 36px;
  height: 36px;
  padding: 12px;
}

.box span {
  color: #111f2c;
  text-decoration: none;
}

.link {
  text-decoration: none;
}

.box-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 25px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.navigation {
  width: 100%;
  margin-top: 30px;
  text-align: right;
  margin-right: 20px;
  float: left;
  color: #909399;
  font-size: 14px;
}

.footA:hover {
  color: #c0c4cc;
  cursor: pointer;
}

.butDiv {
  width: 215px;
  height: 56px;
  margin: 0 15px 25px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  display: inline-block;
  justify-content: flex-start;
  position: relative;
}

.butDiv:hover {
  cursor: pointer;
  border-color: rgb(192, 196, 204);
}

.smallbutDiv {
  display: flex;
  border-radius: 8px;
  width: 100%;
  margin-top: 10px;
  padding-left: 20px;
}

.butImg {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  border-radius: 5px;
}

.butSpan {
  text-align: left;
  line-height: 35px;
}

.secondary {
  color: #909399;
}

.noticeDiv:hover {
  cursor: pointer;
}

.badgeSpan >>> .el-badge__content.is-fixed {
  right: 30px !important;
}
</style>
